import { Component, OnInit, ViewChild } from '@angular/core';
import { KairosService } from '../services/kairos.service';
import { ListadoKairos } from '../models/listadoKairos';
import { Kairos } from '../models/kairos';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router'
import { DoubleBounceComponent } from '../../shared/spinners/double-bounce/double-bounce.component'
import { CustomAlertComponent } from '../../shared/custom-alert/custom-alert.component';

import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-kairos',
  templateUrl: './kairos.component.html',
  styleUrls: ['./kairos.component.scss']
})
export class KairosComponent implements OnInit {

  pagina: number = 0;
  cantidadPorPagina: number = 20;
  listado: ListadoKairos = null;
  paginas: number = 0;
  isLoading = true;
  display:boolean = false;
  esAdmin: boolean = false;
  kairos:Kairos = null;

  alert: any = {
    tipo: "success",
    titulo: "",
    mensaje: "",
    visible: false
  }

  @ViewChild(DoubleBounceComponent)
  spinner: DoubleBounceComponent;

  @ViewChild(CustomAlertComponent)
  private alertComponent: CustomAlertComponent;

  constructor(private kairosService: KairosService, private router: Router, private authService: AuthService) { 
    this.listado = new ListadoKairos();
    this.listado.kairos = new Array<Kairos>();
    this.esAdmin = this.authService.roles.indexOf("administrador") > -1;
  }

  ngOnInit() {
    this.obtenerListado();    
  }

  obtenerListado(paginaActual?: number) {
    this.pagina = paginaActual == null ? 0 : paginaActual;
    this.spinner.isRunning = true;
    this.kairosService.listado(this.pagina, this.cantidadPorPagina).subscribe(result => {
      this.spinner.isRunning = false;
      this.listado = result;
      if (this.listado && this.listado.total > 0) {
        this.paginas = Math.floor((this.listado.total + this.cantidadPorPagina - 1) / this.cantidadPorPagina);
      }
    });
  }

  anterior() {
    this.obtenerListado(this.pagina - 1);
  }

  siguiente() {
    this.obtenerListado(this.pagina + 1);
  }

  paginate(event) {    
    //event.first = Index of the first record
    //event.rows = Number of rows to display in new page
    //event.page = Index of the new page
    //event.pageCount = Total number of pages
    this.obtenerListado(event.page);
  }

  showDialog(kairos: Kairos) {
    this.kairos = kairos;
    this.display = true;
  }

  eliminar() {
    this.display = false;
    this.spinner.isRunning = true;
    this.kairosService.eliminar(this.kairos.id).subscribe(result => {
      this.alert.visible = true;
      this.alert.titulo = "Eliminar archivo";
      if (result.status == 204) {
        this.alert.tipo = "success"
        this.alert.mensaje = `El archivo se ha eliminado correctamente`
      } else {
        this.alert.tipo = "danger"
        this.alert.mensaje = "El archivo no se ha podido eliminar. Por favor vuelva a intentarlo."
      }
      this.alertComponent.setType(this.alert.tipo);
      this.listado.kairos = this.listado.kairos.filter(u => {
        return u.id != this.kairos.id
      });
      this.kairos = null;      
      this.spinner.isRunning = false;
    }, error => {      
      this.spinner.isRunning = false;
      this.alert.visible = true;
      this.alert.titulo = "Eliminar archivo";
      this.alert.tipo = "danger"
      this.alertComponent.setType(this.alert.tipo);
      this.alert.mensaje = "El archivo no se ha podido eliminar. Por favor vuelva a intentarlo."
      
      
    })
  }
}



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/app/intranet/kairos/kairos.component.ts